<template>
  <div>运营表</div>
</template>

<script>
  export default {
    name: "operate"
  }
</script>

<style scoped>

</style>
